// hook-test
// test
import React from 'react'

import * as ReactDOM from 'react-dom/client'

import App from '@/app'
import { AppProviders } from '@/app-providers'

const container = document.getElementById('prospects-root')
const root = ReactDOM.createRoot(container)

root.render(
  <AppProviders>
    <App />
  </AppProviders>,
)
